import { ExternalGoal, externalEvents } from 'src/utils/analytics/external';
import getDefaultAnalyticsParams from 'src/utils/analytics/getDefaultAnalyticsParams';

export const analytics = {
    ...externalEvents,
};

export const Goal = ExternalGoal;

export { getDefaultAnalyticsParams };
